/*
 * Public API Surface of plugin-settings
 */

export * from './lib/app-settings';
export * from './lib/settings.module';
